module.exports = __webpack_public_path__ + "img/imagem-planta-palmeiras.cb50843b.png";